import { format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";

const encodeURL = (method, url) => {
  return `/${method}/${encodeURLpoweredbyMartini(url)}`;
};

const encodeURLpoweredbyMartini = url => {
  return url.replace(/\//g, "&v&");
};

export const getLastDayOfDisplayLogs = lastDay => {
  if (!lastDay) return process.env.VUE_APP_LAST_DAY_DISPLAY_LOG;

  const date = new Date(lastDay);
  if (isNaN(date.getTime())) return "";

  const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const zonedDate = utcToZonedTime(date, localTimeZone);
  return format(zonedDate, "yyyy-MM-dd");
};

export { encodeURL };

